
import React from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { MaintenanceBikeHistory } from "@/components/maintenance/MaintenanceBikeHistory";

interface MaintenanceTabContentProps {
  bikeId: string;
}

const MaintenanceTabContent: React.FC<MaintenanceTabContentProps> = ({ bikeId }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Maintenance History</CardTitle>
        <CardDescription>
          Repair and maintenance records for this bike
        </CardDescription>
      </CardHeader>
      <CardContent>
        <MaintenanceBikeHistory bikeId={bikeId} />
      </CardContent>
    </Card>
  );
};

export default MaintenanceTabContent;
